
function isAndroidOrIOS() {
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        return "android"
    }
    if (isiOS) {
        return "ios"
    }
    return false
}
 // 判断浏览器环境
 function isWeixin () {
   const wx = navigator.userAgent.toLowerCase()
   return wx.indexOf('micromessenger') >= 0
 }
 export default {
    isAndroidOrIOS,isWeixin
 }